<template>
    <div class="card card-height">
        <div class="table-responsive">
            <table class="table custom-table-padding">
                <thead>
                    <tr>
                        <th>Image</th>
                        <th class="name">Name</th>
                        <th>Mobile no</th>
                        <th>Email</th>
                        <th>Location</th>
                        <th>Department</th>
                        <th>Start date</th>
                        <th>End date</th>
                        <th>Status</th>
                        <th class="action-th">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, i) in tableItems" :key="i">

                        <td> 
                            <img :src=item.contact_profile.photo alt="avatar" class="profile-pic">
                        </td>

                        <td>
                            {{ item.contact_profile.full_name }}
                        </td>

                        <td>
                            {{ item.contact_profile.phone }}
                        </td>

                        <td>
                            {{ item.contact_profile.email }}
                        </td>

                        <td>
                            {{ item.area && item.area.name }}
                        </td>

                        <td>
                            {{ item.department && item.department.name }}
                        </td>

                        <td>
                            {{ item.start_date }}
                        </td>

                        <td>
                            {{ item.end_date }}
                        </td>

                        <td>
                            <span class="badge rounded-pill me-1" :class="'badge-light-' + (item.status == 'active' ? 'success' : 'danger')">
                                {{ upperFirst(item.status) }}
                            </span>
                        </td>

                        <td>
                            <div class="action">
                                <button @click="editOTOrder(item)" class="btn btn-primary btn-sm">
                                    <i class="fas fa-eye"></i>
                                </button>
                                <!-- <button @click="editOTOrder(item)" class="btn btn-primary btn-sm">Change area</button> -->
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        <p v-if="!tableItems.length" class="text-center mt-5">No data</p>
    </div>
</div>
</template>

<script setup>
    import { useRoute, useRouter } from "vue-router";
    import { upperFirst } from 'lodash';

    const $route = useRoute();
    const $router = useRouter();

    const props = defineProps({
        tableItems: {
            type: Array,
        },
        onEditSR: Function,
    })

    const emit = defineEmits(['onEditSR']);

    const editOTOrder = (item) => {
        emit('onEditSR', item)
    }

</script>

<style scoped>
.action-th{
    width: 15%;
    text-align: center;
}
.name{
    width: 15%;
}
.action{
    text-align: center;
}

.profile-pic{
    width: 65px;
}
</style>